module.exports = __webpack_public_path__ + "static/img/3.75ff694.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/3.png
// module id = ivxy
// module chunks = 0